import { RFC } from '../../types/propTypes'
import { WHMButton } from '../atoms/atoms'
import { Switch } from '@headlessui/react'

type StatusButtonsProps = {
 /* Delete        -> d 
    Save          -> s 
    Active Status -> as
    Content Title -> ct */
    type: 'd-as-s' | 'ct-d-s' | 'd-s' | 'd-as'
    page?:      string
    title?:     string
    switchTitle?: string
    isActive?:  boolean
    onDelete?:       () => void
    onSave?:         () => void
    onChangeStatus?: () => void
}

const StatusButtons:RFC<StatusButtonsProps> = ({
    type,
    page,
    title,
    switchTitle,
    isActive,
    onDelete, 
    onSave,
    onChangeStatus
}) => {

    const deleteButton = () => {
        if (!onDelete) return
        return (
            <WHMButton 
            text='Delete'
            className='delete-button'
            onSubmit={onDelete}
            />
        )
    }
    
    const saveButton = () => {
        if (!onSave) return
        return (
            <WHMButton 
            text='Save'
            className='save-button'
            onSubmit={onSave}
            />
        )
    }
    
    const activeStatus = () => {
        if (!onChangeStatus) return
        return (
            <div 
                className='w-48 border-[1px] border-solid border-WHMBorder
                rounded-[5px] flex items-center justify-evenly py-[2px] px-2'
            >
                {switchTitle ?? 'Active Status'}
                <Switch 
                    checked={isActive ? true : false}
                    onChange={onChangeStatus}
                    className={`${isActive ? 'bg-WHMBlue' : 'bg-WHMGrey'}
                    relative inline-flex h-8 w-14 items-center rounded-full 
                    border-[1px] border-solid border-WHMBorder`}
                >
                    <span className="sr-only">Use setting</span>
                    <span
                    aria-hidden="true"
                    className={`${isActive ? 'translate-x-6' : '-translate-x-[1px]'}
                    inline-block h-8 w-8 transform rounded-full bg-WHMWhite border-[2px] border-solid 
                    border-WHMBorder transition-all duration-300`}
                    />
                </Switch>
            </div>
        )
    }
    
    const contentTitle = () => {
        return(
            <div className='max-w-[15em] min-w-max w-fit border-[1px] border-solid border-WHMBorder
            rounded-[5px] flex items-center justify-evenly px-2 mr-2'>
                <p className='mr-2 font-semibold'>
                    { title ? 'Assigned' : `Current ${page}` }
                </p>
                <p className='truncate text-WHMDark/80'>
                    { (title && title !== 'NA') ? title : 'NA' }
                </p>
            </div>
        )
    }

    const renderStatusButtons = () => {
        switch (type) {
            case 'd-as-s': 
                return (
                    <div className='flex mr-4'>
                        { deleteButton() }
                        { activeStatus() }
                        { saveButton() }
                    </div>
                )
            case 'ct-d-s':
                return (
                    <div className='flex mr-4'>
                        { contentTitle() }
                        { deleteButton() }
                        { saveButton() }
                    </div>
                )
            case 'd-s':
                return (
                    <div className='flex mr-4'>
                        { deleteButton() }
                        { saveButton() }
                    </div>
                )
            case 'd-as':
                return (
                    <div className='flex mr-4'>
                        { deleteButton() }
                        { activeStatus() }
                    </div>
                )
            default:
                return
        }
    }

    return (
        <div>
            { renderStatusButtons() }
        </div>
    )
}

export default StatusButtons